import { render } from "./follow_requests.vue?vue&type=template&id=19635b62"
import script from "./follow_requests.js?vue&type=script&lang=js"
export * from "./follow_requests.js?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__